import { Link } from "react-router";
import { SITE, SITE_CONTACT, SITE_SOCIALS, TOPICS } from "@jipraks/shared";
import { authorsCopy } from "@client/locales/id/authors";
import { layoutCopy } from "@client/locales/id/layout";

const copy = layoutCopy.footer;
const LINK = "inline-flex min-h-11 items-center text-sm text-foreground-muted transition-colors duration-200 hover:text-foreground md:min-h-9";

export function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-border-default bg-background-deep/60">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[2fr_1fr_1fr_1fr]">
        <div className="flex flex-col gap-4">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="" width={28} height={28} className="size-7 rounded-md" loading="lazy" />
            <span className="text-sm font-semibold text-foreground">{SITE.name}</span>
          </Link>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-muted">{copy.about}</p>
          <ul className="flex flex-wrap gap-x-4">
            {SITE_SOCIALS.map((social) => (
              <li key={social.name}>
                <a href={social.url} target="_blank" rel="noopener noreferrer" className={LINK}>{social.name}</a>
              </li>
            ))}
          </ul>
        </div>

        <nav aria-label={copy.productsTitle}>
          <p className="font-mono text-xs tracking-widest text-foreground-muted uppercase">{copy.productsTitle}</p>
          <ul className="mt-3 flex flex-col">
            <li><Link to="/#katalog" className={LINK}>{layoutCopy.nav.catalog}</Link></li>
            <li><Link to="/blog" className={LINK}>{layoutCopy.nav.blog}</Link></li>
            <li><Link to="/authors" className={LINK}>{authorsCopy.nav}</Link></li>
            <li><Link to="/library" className={LINK}>Produk saya</Link></li>
          </ul>
        </nav>

        <nav aria-label={copy.topicsTitle}>
          <p className="font-mono text-xs tracking-widest text-foreground-muted uppercase">{copy.topicsTitle}</p>
          <ul className="mt-3 flex flex-col">
            {TOPICS.map((topic) => (
              <li key={topic.slug}><Link to={`/topics/${topic.slug}`} className={LINK}>{topic.name}</Link></li>
            ))}
          </ul>
        </nav>

        <nav aria-label={copy.supportTitle}>
          <p className="font-mono text-xs tracking-widest text-foreground-muted uppercase">{copy.supportTitle}</p>
          <ul className="mt-3 flex flex-col">
            <li><a href={SITE_CONTACT.contactFormUrl} target="_blank" rel="noopener noreferrer" className={LINK}>{copy.contact}</a></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-border-default">
        <p className="mx-auto w-full max-w-6xl px-4 py-6 text-xs text-foreground-muted sm:px-6">
          {copy.rights(new Date().getFullYear())}
        </p>
      </div>
    </footer>
  );
}
